import React, { useContext, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import LoadingDialog from 'components/global/LoadingDialog';

export default function MainLayout({ children }) {
    const auth = useSelector((state) => state.auth);

    const system = useSelector((state) => state.system);

    const dispatch = useDispatch();

    return (
        <>
            <div>
                <main>
                    <div>{children}</div>
                </main>
            </div>

            {system.showLoading && <LoadingDialog open={system.showLoading} />}
        </>
    );
}
